import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import { Toggle } from '@thanx/uikit/toggle'
import useLiveUpdatesDevToolsEnabled from 'hooks/useLiveUpdatesDevToolsEnabled'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('nav.profile_menu')

const LABEL_ID = 'live-updates-dev-tools-toggle-label'

// Matches NavLink's own row height so this sits flush with the other
// ProfileMenu rows above and below it.
const ROW_HEIGHT = '40px'

type Props = {
  isLeftNav?: boolean
}

// Visible to every user in any non-production environment (see Body.tsx's
// isNonProductionEnvironment gate) for the Live Updates dev tools -- the
// stack-permutation toolbar and its fetch mock, otherwise only reachable via
// `yarn start`. Off by default; state is shared with the LiveUpdates scene
// through useLiveUpdatesDevToolsEnabled so the two can't drift.
const LiveUpdatesDevToolsToggle = ({ isLeftNav = false }: Props) => {
  const [css] = useStyletron()
  const [enabled, setEnabled] = useLiveUpdatesDevToolsEnabled()

  return (
    <div
      // The @thanx/uikit Toggle's real native input is 0x0/invisible (baseui
      // renders the visible switch as a sibling element for styling), so a
      // real click always lands on that visible sibling and bubbles from
      // there -- stopping it here is required to keep MenuItem's
      // Dropdown.Menu (which closes on ANY bubbled click) from closing the
      // whole ProfileMenu every time this switch is clicked.
      onClick={e => e.stopPropagation()}
      className={`align-items-center d-flex ${
        isLeftNav ? 'px-m' : 'px-s'
      } ${css({ height: ROW_HEIGHT })}`}
    >
      <Text.BodyText4 tag="span" color="grey90">
        <span id={LABEL_ID}>{t('live_updates_dev_tools')}</span>
      </Text.BodyText4>
      <div className="ml-auto">
        <Toggle
          checked={enabled}
          onChange={setEnabled}
          overrides={{
            Input: {
              props: {
                role: 'switch',
                'aria-labelledby': LABEL_ID,
              },
            },
          }}
        />
      </div>
    </div>
  )
}

export default LiveUpdatesDevToolsToggle
